/* Spicy Cube 2 LP (híu): runtime for the ej-lp-* sections.
   Config (dates, gift, bundles) comes from window.EJ, printed by the "LP · Core settings" section.
   Every init is idempotent and re-runs on shopify:section:load, so editing a section in the
   theme editor never breaks the bundle picker, CTAs, gallery, carousels, countdown or sticky bar. */
(function () {
  "use strict";
  var EJ = window.EJ;
  if (!EJ) return;
  var $ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var now = Date.now();
  var perkEnd = new Date(EJ.perk.end).getTime();
  var start = new Date(EJ.start).getTime();
  var preview = !!window.EJ_PREVIEW;
  var perkLive = !!EJ.perk.on && now < perkEnd && (now >= start || preview);
  var current = null;

  function bind(el, ev, fn) {
    var k = "__ej_" + ev;
    if (!el || el[k]) return;
    el[k] = true;
    el.addEventListener(ev, fn);
  }
  function lines(b) { return String(b.items || "").replace(/\s+/g, "").split(",").filter(Boolean); }
  function ids(b) { return lines(b).map(function (x) { return x.split(":")[0]; }); }
  var ids_ = ids;
  /* Cart lines of a bundle. The gift (blindfold) is part of the Best Value bundle the store's
     discount expects: "B2G5 JAR" = buy one 2 Jar, get 4 free among 2 Jar, Blind Fold, 365 guide and
     Pearl Panties, and it only applies when all four are in the cart. So the gift is always added,
     once, not only while the birthday perk runs (without it the bundle loses its $89.99 price). */
  function bundleLines(b) {
    var l = lines(b), v = EJ.perk && EJ.perk.variant ? String(EJ.perk.variant).trim() : "";
    if (b.perk && /^\d+$/.test(v) && !l.some(function (x) { return x.split(":")[0] === v; })) l.push(v + ":1");
    return l;
  }
  function cartUrl(key) {
    var b = EJ.bundles[key];
    if (!b) return "#";
    var l = bundleLines(b);
    return (EJ.store || "") + "/cart/" + l.join(",") + (b.code ? "?discount=" + encodeURIComponent(b.code) : "");
  }

  /* Fill shared values, hide "live only" bits outside the gift window */
  function fill() {
    if (EJ.perk.on && now >= perkEnd) document.body.classList.add("is-ended");
    var rib = document.getElementById("ejPreview");
    if (rib && EJ.showPreviewRibbon && preview && now < start) rib.hidden = false;
    $("[data-guar]").forEach(function (el) { el.textContent = EJ.guaranteeDays; });
    $("[data-perk-end]").forEach(function (el) { el.textContent = EJ.perk.endLabel; });
    $("[data-perk-name]").forEach(function (el) { el.textContent = EJ.perk.name; });
    if (!EJ.showCompareAt) $("[data-cmp]").forEach(function (el) { el.hidden = true; });
    if (!perkLive) $(".ej-live").forEach(function (el) { el.hidden = true; });
  }

  /* Bundle picker -> CTA hrefs, labels, sticky bar, birthday-bonus strip */
  function select(key) {
    var b = EJ.bundles[key];
    if (!b) return;
    current = key;
    var url = cartUrl(key);
    $("[data-cta]").forEach(function (a) {
      var own = a.getAttribute("data-pick");
      a.href = own && EJ.bundles[own] ? cartUrl(own) : url;
    });
    $("[data-cta-label]").forEach(function (el) { el.textContent = perkLive ? b.cta : b.ctaNoPerk; });
    $("[data-sticky-label]").forEach(function (el) { el.textContent = b.label; });
    $("[data-sticky-pill]").forEach(function (el) { el.hidden = !(perkLive && b.perk); });
    var bonus = document.getElementById("ejBonus");
    if (bonus && perkLive) {
      var up = !b.perk;
      bonus.classList.toggle("up", up);
      var t = bonus.querySelector("[data-bonus-title]"), s = bonus.querySelector("[data-bonus-sub]");
      if (t) t.textContent = bonus.getAttribute(up ? "data-title-up" : "data-title-on") || t.textContent;
      if (s) s.textContent = bonus.getAttribute(up ? "data-sub-up" : "data-sub-on") || s.textContent;
    }
  }
  function pick(key) {
    var r = document.querySelector("input[name=ejBundle][value=" + key + "]");
    if (r && !r.checked) { r.checked = true; select(key); }
  }
  function initBundles() {
    $("input[name=ejBundle]").forEach(function (r) { bind(r, "change", function () { select(r.value); }); });
    var c = document.querySelector("input[name=ejBundle]:checked");
    var key = c ? c.value : (current || Object.keys(EJ.bundles || {})[0]);
    if (key) select(key);
  }
  function track(key) {
    var b = EJ.bundles[typeof key === "string" ? key : current];
    if (!b) return;
    var v = ids(b);
    try { if (window.fbq) fbq("track", "AddToCart", { value: b.value, currency: "USD", content_ids: v, content_type: "product" }); } catch (e) {}
    try { if (window.ttq) ttq.track("AddToCart", { value: b.value, currency: "USD", content_id: v[0], content_type: "product" }); } catch (e) {}
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish("ej_lp_checkout_click", { bundle: current, value: b.value, variant_ids: v }); } catch (e) {}
  }

  /* Cart drawer (sections/ej-lp-cart.liquid).
     Bundle buttons add through the AJAX Cart API and open the drawer. The drawer HTML always comes
     back from Shopify in the same request (Section Rendering API), so prices, free gifts and totals
     are the real cart with the store's automatic discounts applied. Each bundle replaces any bundle
     already in the cart, so two clicks never stack two bundles or mix discounts that do not combine.
     Any network failure falls back to the cart permalink, which still lands on checkout. */
  var CART_SECTION = "ej-lp-cart-it";
  var cartBusy = false, cartFocus = null, cartWired = false;
  function cartEl() { return document.getElementById("ejCart"); }
  function cartReady() { return !!(cartEl() && window.fetch && window.DOMParser && window.JSON); }
  function root() { return (window.Shopify && Shopify.routes && Shopify.routes.root) || "/"; }
  function req(path, body, ms) {
    var ctl = window.AbortController ? new AbortController() : null;
    var timer = ctl ? setTimeout(function () { ctl.abort(); }, ms || 15000) : 0;
    // GETs keep the default Accept header: with "application/json" Shopify answers a page URL
    // with the page's JSON instead of the Section Rendering payload.
    var opts = { method: body ? "POST" : "GET", credentials: "same-origin", headers: {} };
    if (body) {
      opts.headers = { Accept: "application/json", "Content-Type": "application/json", "X-Requested-With": "XMLHttpRequest" };
      opts.body = JSON.stringify(body);
    }
    if (ctl) opts.signal = ctl.signal;
    return fetch(path.charAt(0) === "/" ? path : root() + path, opts).then(function (r) {
      clearTimeout(timer);
      return r.json().catch(function () { return {}; }).then(function (d) {
        if (!r.ok) { var e = new Error(d.description || d.message || "HTTP " + r.status); e.status = r.status; throw e; }
        return d;
      });
    }, function (err) { clearTimeout(timer); err.status = 0; throw err; });
  }
  function withSection(body) { body.sections = CART_SECTION; body.sections_url = location.pathname; return body; }
  function swapCart(d) {
    var html = d && d.sections && d.sections[CART_SECTION];
    if (!html) return false;
    var fresh = new DOMParser().parseFromString(html, "text/html").getElementById("ejCartIn");
    var cur = document.getElementById("ejCartIn");
    if (!fresh || !cur) return false;
    var hadFocus = cur.contains(document.activeElement);
    var next = document.importNode(fresh, true);
    cur.parentNode.replaceChild(next, cur);
    if (!perkLive) $(".ej-live", next).forEach(function (el) { el.hidden = true; });
    else if (cdOn) paintCd();
    if (hadFocus) focusCart();
    syncCount();
    loadToken();
    return true;
  }
  /* The cart's token (with its ?key=) lets checkout open this exact cart from a new tab, where the
     page's cookies may not be shared (theme editor preview). Re-read after every cart change. */
  var cartTok = "", tokTimer = 0;
  function loadToken() {
    clearTimeout(tokTimer);
    tokTimer = setTimeout(function () {
      if (cartCount() < 1) { cartTok = ""; return; }
      // Only trust a token for the same cart the drawer shows (same item count).
      req("cart.js").then(function (c) { noteCodes(c); cartTok = c && c.token && c.item_count === cartCount() ? c.token : ""; }, function () { cartTok = ""; });
    }, 120);
  }
  function refreshCart() {
    return req(location.pathname + "?sections=" + CART_SECTION).then(function (d) { swapCart({ sections: d }); });
  }
  function cartCount() { var c = document.getElementById("ejCartIn"); return c ? parseInt(c.getAttribute("data-count"), 10) || 0 : 0; }
  function syncCount() {
    var n = cartCount();
    $(".ej-hd-cart").forEach(function (a) {
      var badge = a.querySelector(".ej-hd-badge");
      if (n > 0) { if (!badge) { badge = document.createElement("span"); badge.className = "ej-hd-badge"; a.appendChild(badge); } badge.textContent = n; }
      else if (badge) badge.parentNode.removeChild(badge);
      a.setAttribute("aria-label", "Carrello, " + n + (n === 1 ? " articolo" : " articoli"));
    });
  }
  function cartError(msg) {
    var e = document.getElementById("ejCartErr");
    if (!e) return;
    e.textContent = msg || "";
    e.hidden = !msg;
    clearTimeout(e.__t);
    if (msg) e.__t = setTimeout(function () { e.hidden = true; }, 6000);
  }
  function focusCart() {
    var el = cartEl(); if (!el) return;
    var x = el.querySelector(".ej-dw-close") || el.querySelector(".ej-dw-panel");
    try { x.focus({ preventScroll: true }); } catch (e) {}
  }
  function openCart(from) {
    var el = cartEl(); if (!el) return;
    if (from) cartFocus = from;
    if (el.classList.contains("is-open")) return;
    el.hidden = false;
    void el.offsetWidth;
    el.classList.add("is-open");
    document.documentElement.classList.add("ej-dw-lock");
    setTimeout(focusCart, 60);
  }
  function closeCart() {
    var el = cartEl(); if (!el || !el.classList.contains("is-open")) return;
    el.classList.remove("is-open");
    document.documentElement.classList.remove("ej-dw-lock");
    setTimeout(function () { if (!el.classList.contains("is-open")) el.hidden = true; }, 360);
    if (cartFocus && cartFocus.focus) { try { cartFocus.focus({ preventScroll: true }); } catch (e) {} }
    cartFocus = null;
  }
  function setBusy(on, btn) {
    cartBusy = on;
    var el = cartEl(); if (el) el.classList.toggle("is-busy", on);
    $("[data-cta]").forEach(function (a) { a.setAttribute("aria-disabled", on ? "true" : "false"); });
    if (btn) { btn.classList.toggle("is-loading", on); if (on) btn.setAttribute("aria-busy", "true"); else btn.removeAttribute("aria-busy"); }
  }
  function noop() {}
  /* Is the page inside a frame? Storefront pages refuse framing (frame-ancestors 'none'), so in
     practice this is the theme editor preview. Shopify checkout refuses frames too: loading it there
     shows "... refused to connect" (ERR_BLOCKED_BY_RESPONSE). */
  function framed() {
    try { return window.self !== window.top; } catch (e) { return true; }
  }
  function absUrl(url) {
    try { return new URL(url, location.href).href; } catch (e) { return url; }
  }
  /* New tab without handing it a reference back to this page. Returns false when popups are blocked. */
  function openTab(abs) {
    var w = null;
    try { w = window.open(abs, "_blank"); } catch (e) {}
    if (!w) return false;
    try { w.opener = null; } catch (e) {}
    return true;
  }
  /* Top-level navigation. Inside a frame it leaves the frame (new tab in the theme editor, so the
     editor stays open) and never loads checkout inside the frame. */
  function go(url) {
    var abs = absUrl(url);
    if (!framed()) { location.href = abs; return; }
    if (window.Shopify && Shopify.designMode) { if (!openTab(abs)) checkoutNote(abs); return; }
    try { window.top.location.href = abs; return; } catch (e) {}
    if (!openTab(abs)) checkoutNote(abs);
  }
  /* Last resort when the browser blocks both: a link the shopper (or editor user) can click. */
  function checkoutNote(abs) {
    var e = document.getElementById("ejCartErr");
    if (!e) return;
    clearTimeout(e.__t);
    e.textContent = "Il checkout non può aprirsi in questa anteprima. ";
    var a = document.createElement("a");
    a.href = abs; a.target = "_blank"; a.rel = "noopener";
    a.textContent = "Apri il checkout in una nuova scheda";
    a.style.cssText = "color:inherit;text-decoration:underline;text-underline-offset:2px";
    e.appendChild(a);
    e.hidden = false;
    e.__t = setTimeout(function () { e.hidden = true; }, 15000);
  }
  /* Checkout link built from exactly what the drawer shows (same lines, same quantities, same
     codes). Shopify re-applies the automatic discounts, so checkout matches the drawer total. */
  function drawerCheckoutUrl() {
    var wrap = document.getElementById("ejCartIn"), qty = {}, order = [];
    $("#ejCartIn [data-vid]").forEach(function (li) {
      var v = li.getAttribute("data-vid"), q = parseInt(li.getAttribute("data-qty"), 10) || 0;
      if (!/^\d+$/.test(v || "") || q < 1) return;
      if (!qty[v]) order.push(v);
      qty[v] = (qty[v] || 0) + q;
    });
    if (!order.length) return root() + "checkout";
    var url = (EJ.store || "") + "/cart/" + order.map(function (v) { return v + ":" + qty[v]; }).join(",");
    var own = ownCodes(), codes = cartCodes().filter(function (x) { return !bundleInCart() || own[x.toUpperCase()]; }).join(",");
    return codes ? url + "?discount=" + encodeURIComponent(codes) : url;
  }
  /* Checkout link for this exact cart (same lines, line properties, discounts): /cart/c/<token>?key=…
     opens the cart by its token, so it works in a new tab even where cookies aren't shared. */
  function cartTokenUrl() {
    var w = document.getElementById("ejCartIn"), t = cartTok || (w ? w.getAttribute("data-token") || "" : "");
    var i = t.indexOf("?key=");
    if (i < 1 || cartCount() < 1) return "";
    return root() + "cart/c/" + encodeURIComponent(t.slice(0, i)) + t.slice(i);
  }
  /* Checkout = the very cart the drawer shows (same lines, gifts, discounts). If the browser has
     not started leaving the page shortly after, open checkout from the drawer's lines instead. */
  function goCheckout() {
    if (framed()) { go(cartTokenUrl() || drawerCheckoutUrl()); return; }
    var left = false, mark = function () { left = true; };
    window.addEventListener("beforeunload", mark, { once: true });
    window.addEventListener("pagehide", mark, { once: true });
    go(root() + "checkout");
    setTimeout(function () { if (!left && !document.hidden) go(cartTokenUrl() || drawerCheckoutUrl()); }, 3500);
  }
  function friendly(err, fallback) {
    var m = err && err.message;
    return m && !/^HTTP \d+$/.test(m) && err.name !== "AbortError" && err.name !== "TypeError" ? m : fallback;
  }
  /* A page restored with Back (from checkout, say) can show an old cart: re-read it first. */
  var cartSync = null;
  function syncCart(force) {
    if (force || !cartSync) cartSync = refreshCart().catch(noop);
    return cartSync;
  }
  function bundleItems(key) {
    var b = EJ.bundles[key], qty = {};
    if (!b) return [];
    var l = bundleLines(b);
    l.forEach(function (x) { var p = x.split(":"), id = p[0]; if (/^\d+$/.test(id)) qty[id] = (qty[id] || 0) + (parseInt(p[1], 10) || 1); });
    return Object.keys(qty).map(function (id) { return { id: Number(id), quantity: qty[id], properties: { _ej_bundle: key } }; });
  }
  /* Lines a new bundle replaces: every bundle line, plus loose lines of the same products
     (a jar or gift added elsewhere would otherwise take a free slot and change the bundle price). */
  function bundleKeys() {
    var ids = {}, keys = [];
    Object.keys(EJ.bundles || {}).forEach(function (k) { ids_(EJ.bundles[k]).forEach(function (id) { ids[id] = 1; }); });
    if (EJ.perk && EJ.perk.variant) ids[String(EJ.perk.variant).trim()] = 1;
    $("#ejCartIn [data-keys]").forEach(function (g) { keys = keys.concat(String(g.getAttribute("data-keys")).split(/\s+/).filter(Boolean)); });
    $("#ejCartIn [data-key]").forEach(function (li) {
      var key = li.getAttribute("data-key");
      if (ids[key.split(":")[0]] && keys.indexOf(key) < 0) keys.push(key);
    });
    return keys;
  }
  function clearBundles() {
    var keys = bundleKeys();
    if (!keys.length) return Promise.resolve();
    var u = {};
    keys.forEach(function (k) { u[k] = 0; });
    return req("cart/update.js", { updates: u });
  }
  /* Adds the bundle; on a 422 (a gift sold out, a quantity rule) adds what it can line by line. */
  function addItems(items) {
    return req("cart/add.js", withSection({ items: items })).catch(function (err) {
      if (err.status !== 422 || items.length < 2) throw err;
      var added = 0, chain = Promise.resolve();
      items.forEach(function (it) {
        chain = chain.then(function () { return req("cart/add.js", { items: [it] }).then(function () { added++; }, function () {}); });
      });
      return chain.then(function () {
        if (!added) throw err;
        return req(location.pathname + "?sections=" + CART_SECTION).then(function (d) {
          cartError("One item in this bundle is unavailable right now, the rest is in your cart.");
          return { sections: d };
        });
      });
    });
  }
  function setBundle(key, btn) {
    if (cartBusy) return;
    var items = bundleItems(key);
    if (!items.length) return;
    var b = EJ.bundles[key];
    cartError("");
    setBusy(true, btn);
    openCart(btn);
    (cartSync || Promise.resolve())
      .then(clearBundles)
      .catch(function () { return refreshCart().then(clearBundles); })
      .then(function () { return addItems(items); })
      .then(function (d) {
        if (!swapCart(d)) return refreshCart();
      })
      .then(function () {
        track(key);
        if (b.code) return req("cart/update.js", withSection({ discount: b.code })).then(swapCart, function () {});
        return stripCodes();
      })
      .then(function () { setBusy(false, btn); }, function (err) {
        var st = err && err.status;
        if (st === 400 || st === 422) {
          setBusy(false, btn);
          cartError(friendly(err, "Qualcosa è andato storto. Riprova."));
          refreshCart().catch(noop);
          return;
        }
        // Network, blocked or server error: never strand the shopper, take the bundle straight to checkout.
        setBusy(false, btn);
        cartError("Ti stiamo portando al checkout sicuro\u2026");
        go(cartUrl(key));
      });
  }
  /* Repair a bundle that is missing a line, e.g. a Best Value bundle added before the gift was always
     part of it: "B2G5 JAR" only prices it at $89.99 with every free item in the cart. Adds only what
     is missing, at most once per page view, so a sold-out gift can never cause a loop. */
  var healTried = false;
  function healBundles() {
    if (healTried || cartBusy || !cartReady()) return Promise.resolve();
    var miss = [];
    Object.keys(EJ.bundles || {}).forEach(function (k) {
      var g = document.querySelector('#ejCartIn [data-bundle="' + k + '"]');
      if (!g) return;
      var have = {};
      $("[data-vid]", g).forEach(function (li) {
        var v = li.getAttribute("data-vid");
        have[v] = (have[v] || 0) + (parseInt(li.getAttribute("data-qty"), 10) || 0);
      });
      bundleItems(k).forEach(function (it) {
        var d = it.quantity - (have[String(it.id)] || 0);
        if (d > 0) miss.push({ id: it.id, quantity: d, properties: it.properties });
      });
    });
    if (!miss.length) return Promise.resolve();
    healTried = true;
    return req("cart/add.js", withSection({ items: miss }))
      .then(function (d) { if (!swapCart(d)) return refreshCart(); })
      .catch(noop);
  }
  /* A bundle has its own price: no other code rides along to checkout. Shopify keeps a code from a
     /discount/CODE link (email, ad, popup) in the "discount_code" cookie and re-applies it at checkout,
     so while a bundle is in the cart both that cookie and the cart's codes are cleared. A code set on
     the bundle itself in LP · Core settings is kept. */
  function bundleInCart() { return !!document.querySelector("#ejCartIn [data-bundle]"); }
  function ownCodes() {
    var c = {};
    Object.keys(EJ.bundles || {}).forEach(function (k) {
      String(EJ.bundles[k].code || "").split(",").forEach(function (x) { x = x.trim().toUpperCase(); if (x) c[x] = 1; });
    });
    return c;
  }
  /* Discount codes on the cart, as /cart.js reports them (codes applied from a link or the cookie do
     not always show in the drawer's Liquid). Refreshed on every cart read. */
  var seenCodes = null;
  function noteCodes(c) {
    if (c && c.discount_codes) seenCodes = c.discount_codes.map(function (d) { return String(d.code || ""); }).filter(Boolean);
  }
  function cartCodes() {
    if (seenCodes) return seenCodes.slice();
    var w = document.getElementById("ejCartIn");
    return String(w ? w.getAttribute("data-codes") || "" : "").split(",").map(function (x) { return x.trim(); }).filter(Boolean);
  }
  function dropCookieCode() {
    var m = document.cookie.match(/(?:^|;\s*)discount_code=([^;]*)/);
    if (!m) return;
    var v = "";
    try { v = decodeURIComponent(m[1] || ""); } catch (e) { v = m[1] || ""; }
    if (v && ownCodes()[v.trim().toUpperCase()]) return;
    var host = location.hostname, p = host.split(".");
    ["", "; domain=" + host, p.length > 2 ? "; domain=." + p.slice(-2).join(".") : ""].forEach(function (d) {
      document.cookie = "discount_code=; Max-Age=0; path=/" + d;
    });
  }
  var stripping = null, forceCo = false;
  function stripCodes() {
    if (!bundleInCart()) return Promise.resolve();
    dropCookieCode();
    if (stripping) return stripping;
    stripping = req("cart.js")
      .then(function (c) {
        noteCodes(c);
        var own = ownCodes(), all = cartCodes(), keep = all.filter(function (x) { return own[x.toUpperCase()]; });
        if (keep.length === all.length) return;
        return req("cart/update.js", withSection({ discount: keep.join(",") })).then(function (d) {
          seenCodes = keep;
          if (!swapCart(d)) return refreshCart();
        });
      })
      .catch(noop)
      .then(function () { stripping = null; });
    return stripping;
  }
  function needsStrip() {
    if (!bundleInCart()) return false;
    var own = ownCodes();
    return cartCodes().some(function (x) { return !own[x.toUpperCase()]; });
  }
  function tidyCart() { return healBundles().then(stripCodes); }
  function cartChange(body) {
    if (cartBusy) return;
    cartError("");
    setBusy(true);
    req(body.updates || body.discount ? "cart/update.js" : "cart/change.js", withSection(body))
      .then(function (d) { if (!swapCart(d)) return refreshCart(); })
      .catch(function (err) { cartError(friendly(err, "Impossibile aggiornare il carrello. Riprova.")); return refreshCart().catch(noop); })
      .then(function () { setBusy(false); });
  }
  function initCart() {
    var el = cartEl();
    if (el && !perkLive) $(".ej-live", el).forEach(function (x) { x.hidden = true; });
    syncCount();
    if (cartWired) return;
    cartWired = true;
    document.addEventListener("click", function (e) {
      var t = e.target instanceof Element ? e.target : null;
      if (!t || !cartEl()) return;
      var hd = t.closest(".ej-hd-cart, a[href$='/cart']");
      if (hd && !t.closest("#ejCart")) { e.preventDefault(); openCart(hd); return; }
      if (!t.closest("#ejCart")) return;
      var x;
      if ((x = t.closest("[data-dw-close]"))) {
        if (x.hasAttribute("data-dw-shop")) {
          e.preventDefault();
          closeCart();
          var buy = document.getElementById("ejBuy");
          if (buy) buy.scrollIntoView({ behavior: "smooth", block: "start" });
        } else closeCart();
        return;
      }
      if ((x = t.closest("[data-dw-remove-bundle]"))) {
        var g = x.closest("[data-keys]"), u = {};
        String(g ? g.getAttribute("data-keys") : "").split(/\s+/).filter(Boolean).forEach(function (k) { u[k] = 0; });
        if (Object.keys(u).length) cartChange({ updates: u });
        return;
      }
      if ((x = t.closest("[data-dw-qty]"))) {
        var li = x.closest("[data-key]");
        if (li) cartChange({ id: li.getAttribute("data-key"), quantity: Math.max(0, parseInt(x.getAttribute("data-dw-qty"), 10) || 0) });
        return;
      }
      if ((x = t.closest("[data-dw-upgrade]"))) {
        var k = x.getAttribute("data-dw-upgrade");
        pick(k);
        setBundle(k, x);
        return;
      }
      if ((x = t.closest("[data-dw-checkout]"))) {
        x.classList.add("is-loading");
        setTimeout(function () { x.classList.remove("is-loading"); }, 8000);
      }
    });
    document.addEventListener("keydown", function (e) {
      var el = cartEl();
      if (!el || !el.classList.contains("is-open")) return;
      if (e.key === "Escape") { e.preventDefault(); closeCart(); return; }
      if (e.key !== "Tab") return;
      var f = $("a[href], button:not([disabled]), input, select, textarea, [tabindex]:not([tabindex='-1'])", el.querySelector(".ej-dw-panel")).filter(function (n) { return n.offsetParent !== null; });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
    window.addEventListener("pageshow", function (e) {
      $(".is-loading").forEach(function (x) { x.classList.remove("is-loading"); });
      if (cartBusy) setBusy(false);
      if (e.persisted && cartEl()) syncCart(true).then(tidyCart);
    });
    try {
      var nav = performance.getEntriesByType && performance.getEntriesByType("navigation")[0];
      if (nav && nav.type === "back_forward" && cartEl()) syncCart(true).then(tidyCart);
    } catch (e) {}
    loadToken();
    if (cartCount() > 0) setTimeout(tidyCart, 300);
    // Straight-to-checkout button: runs before any app click handler (window capture phase).
    // In a frame (theme editor) every checkout click is handled here, so no app can load checkout
    // inside the frame.
    window.addEventListener("click", function (e) {
      var t = e.target instanceof Element ? e.target.closest("[data-dw-checkout]") : null;
      if (!t) return;
      if (bundleInCart()) dropCookieCode();
      if (!forceCo && needsStrip()) {
        // The cart still carries another code: clear it, then carry on to checkout (once, no loop).
        e.preventDefault();
        e.stopImmediatePropagation();
        t.classList.add("is-loading");
        stripCodes().then(function () {
          t.classList.remove("is-loading");
          var b = document.querySelector("[data-dw-checkout]") || t;
          forceCo = true;
          try {
            if (b.hasAttribute("data-dw-direct") || framed()) { b.classList.add("is-loading"); goCheckout(); }
            else b.click();
          } finally { forceCo = false; }
        });
        return;
      }
      if (!t.hasAttribute("data-dw-direct") && !framed()) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      t.classList.add("is-loading");
      setTimeout(function () { t.classList.remove("is-loading"); }, 8000);
      goCheckout();
    }, true);
    window.addEventListener("submit", function (e) {
      var f = e.target;
      if (!framed() || !(f instanceof Element) || !f.classList.contains("ej-dw-form")) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      goCheckout();
    }, true);
  }

  function initCtas() {
    $("[data-cta]").forEach(function (a) {
      bind(a, "click", function (e) {
        // No drawer on the page (or a very old browser): keep the cart-permalink checkout link.
        if (!cartReady()) { track(); return; }
        e.preventDefault();
        var k = a.getAttribute("data-pick");
        if (k && EJ.bundles[k]) { pick(k); setBundle(k, a); } else setBundle(current, a);
      });
    });
    $("[data-pick]").forEach(function (a) {
      var k = a.getAttribute("data-pick");
      if (k) bind(a, "click", function () { pick(k); });
    });
    var bonus = document.getElementById("ejBonus");
    if (bonus) {
      var go = function () { if (bonus.classList.contains("up")) pick(bonus.getAttribute("data-pick-up") || "b3"); };
      bind(bonus, "click", go);
      bind(bonus, "keydown", function (e) { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); go(); } });
    }
  }

  /* Gallery: swipe/arrow slider with an infinite loop; thumbs and counter stay in sync.
     Old markup (no .ej-gal-track) keeps the plain thumb -> main image swap. */
  function initGallery() {
    $(".ej-gal").forEach(function (gal) {
      var track = gal.querySelector(".ej-gal-track");
      var thumbs = $(".ej-thumb", gal);
      if (!track) {
        var main = gal.querySelector(".ej-gal-main img");
        thumbs.forEach(function (t) {
          bind(t, "click", function () {
            thumbs.forEach(function (x) { x.classList.remove("on"); });
            t.classList.add("on");
            if (main) { main.removeAttribute("srcset"); main.removeAttribute("sizes"); main.src = t.getAttribute("data-src"); }
          });
        });
        return;
      }
      if (gal.__ej_gal) return;
      gal.__ej_gal = true;
      var box = gal.querySelector(".ej-gal-main");
      var slides = $(".ej-gal-slide", track), n = slides.length;
      var counter = gal.querySelector("[data-gal-i]");
      var pos = 1, timer = 0;
      function realIdx() { return ((pos - 1) % n + n) % n; }
      function move(px, smooth) {
        track.style.transition = smooth ? "transform .4s cubic-bezier(.22,.61,.36,1)" : "none";
        track.style.transform = "translate3d(calc(" + (-pos * 100) + "% + " + (px || 0) + "px),0,0)";
      }
      function eager(k) { var im = slides[(k + n) % n].querySelector("img"); if (im && im.getAttribute("loading") === "lazy") im.setAttribute("loading", "eager"); }
      function paint() {
        var r = realIdx();
        thumbs.forEach(function (t, k) { t.classList.toggle("on", k === r); t.setAttribute("aria-current", k === r ? "true" : "false"); });
        slides.forEach(function (sl, k) { sl.setAttribute("aria-hidden", k === r ? "false" : "true"); });
        if (counter) counter.textContent = r + 1;
        eager(r - 1); eager(r + 1);
      }
      function mark() { $(".ej-gal-slide", track).forEach(function (sl, k) { sl.classList.toggle("is-cur", k === pos); }); }
      function settle() {
        clearTimeout(timer);
        if (pos <= 0) { pos = n; move(0, false); void track.offsetWidth; }
        else if (pos >= n + 1) { pos = 1; move(0, false); void track.offsetWidth; }
        mark();
        track.classList.remove("is-moving");
      }
      function step(d) { settle(); go(pos + d); }
      function go(p) {
        settle();
        pos = p;
        track.classList.add("is-moving");
        move(0, true);
        paint();
        clearTimeout(timer);
        timer = setTimeout(settle, 450);
      }
      if (n < 2) { paint(); return; }
      var head = slides[n - 1].cloneNode(true), tail = slides[0].cloneNode(true);
      [head, tail].forEach(function (c) {
        c.setAttribute("aria-hidden", "true"); c.removeAttribute("aria-label"); c.className += " is-clone";
        var im = c.querySelector("img"); if (im) { im.alt = ""; im.removeAttribute("fetchpriority"); }
      });
      track.insertBefore(head, slides[0]);
      track.appendChild(tail);
      move(0, false);
      paint();
      mark();
      track.classList.add("is-ready");
      track.addEventListener("transitionend", function (e) { if (e.target === track) settle(); });
      $("[data-gal-dir]", gal).forEach(function (btn) {
        btn.addEventListener("click", function () { step(parseInt(btn.getAttribute("data-gal-dir"), 10)); });
      });
      thumbs.forEach(function (t, k) { t.addEventListener("click", function () { if (realIdx() !== k || pos < 1 || pos > n) go(k + 1); }); });
      var sx = 0, sy = 0, dx = 0, axis = 0, t0 = 0, down = false;
      box.addEventListener("touchstart", function (e) {
        if (e.touches.length > 1) return;
        settle();
        track.classList.add("is-moving");
        down = true; axis = 0; dx = 0; t0 = Date.now();
        sx = e.touches[0].clientX; sy = e.touches[0].clientY;
      }, { passive: true });
      box.addEventListener("touchmove", function (e) {
        if (!down) return;
        var mx = e.touches[0].clientX - sx, my = e.touches[0].clientY - sy;
        if (!axis) { if (Math.abs(mx) < 6 && Math.abs(my) < 6) return; axis = Math.abs(mx) > Math.abs(my) ? 1 : 2; }
        if (axis !== 1) return;
        if (e.cancelable) e.preventDefault();
        dx = mx;
        move(dx, false);
      }, { passive: false });
      function release() {
        if (!down) return;
        down = false;
        if (axis !== 1) { track.classList.remove("is-moving"); return; }
        var w = box.clientWidth || 1, fast = Math.abs(dx) > 24 && Date.now() - t0 < 260;
        if (Math.abs(dx) > w * 0.16 || fast) step(dx < 0 ? 1 : -1); else go(pos);
      }
      box.addEventListener("touchend", release);
      box.addEventListener("touchcancel", release);
      gal.addEventListener("keydown", function (e) {
        if (e.key === "ArrowLeft") { e.preventDefault(); step(-1); }
        else if (e.key === "ArrowRight") { e.preventDefault(); step(1); }
      });
    });
  }
  document.addEventListener("shopify:block:select", function (e) {
    var t = e.target && e.target.closest && e.target.closest(".ej-thumb");
    if (t) t.click();
  });

  /* Nutrition label modal */
  var lastBtn = null;
  function initModal() {
    var modal = document.getElementById("ejModal");
    if (!modal) return;
    var x = document.getElementById("ejModalX");
    var close = function () { modal.hidden = true; if (lastBtn) lastBtn.focus(); };
    $("[data-label-btn]").forEach(function (btn) { bind(btn, "click", function () { lastBtn = btn; modal.hidden = false; if (x) x.focus(); }); });
    if (x) bind(x, "click", close);
    bind(modal, "click", function (e) { if (e.target === modal) close(); });
    bind(document, "keydown", function (e) { var m = document.getElementById("ejModal"); if (e.key === "Escape" && m && !m.hidden) { m.hidden = true; if (lastBtn) lastBtn.focus(); } });
  }

  /* Carousels: arrows + dots */
  function initCarousels() {
    $(".ej-nav[data-car]").forEach(function (nav) {
      if (nav.__ej_car) return;
      var track = document.getElementById(nav.getAttribute("data-car"));
      if (!track || track.closest("[hidden]")) return;
      nav.__ej_car = true;
      var items = $(":scope > *", track), dots = nav.querySelector(".ej-dots");
      if (dots) { dots.innerHTML = ""; items.forEach(function (_, i) { var d = document.createElement("i"); if (!i) d.className = "on"; dots.appendChild(d); }); }
      function idx() { var best = 0, bd = 1e9, mid = track.scrollLeft + track.clientWidth / 2; items.forEach(function (it, i) { var c = it.offsetLeft + it.offsetWidth / 2, dd = Math.abs(c - mid); if (dd < bd) { bd = dd; best = i; } }); return best; }
      function paint() { if (!dots) return; var i = idx(); $("i", dots).forEach(function (d, k) { d.className = k === i ? "on" : ""; }); }
      track.addEventListener("scroll", function () { window.requestAnimationFrame(paint); }, { passive: true });
      $(".ej-arrow", nav).forEach(function (btn) {
        btn.addEventListener("click", function () {
          if (!items.length) return;
          var i = Math.max(0, Math.min(items.length - 1, idx() + parseInt(btn.getAttribute("data-dir"), 10)));
          track.scrollTo({ left: items[i].offsetLeft - (track.clientWidth - items[i].offsetWidth) / 2, behavior: "smooth" });
        });
      });
    });
  }

  /* Review-widget placeholder tabs */
  function initTabs() {
    $(".ej-rw-tabs button").forEach(function (b) {
      bind(b, "click", function () { $("button", b.parentNode).forEach(function (x) { x.setAttribute("aria-pressed", x === b ? "true" : "false"); }); });
    });
  }

  /* Birthday countdown: counts to EJ.perk.end, stops at zero, never restarts */
  var cdOn = false;
  function pad(n) { return (n < 10 ? "0" : "") + n; }
  function paintCd() {
    var left = Math.max(0, Math.floor((perkEnd - Date.now()) / 1000));
    var v = { d: pad(Math.floor(left / 86400)), h: pad(Math.floor(left % 86400 / 3600)), m: pad(Math.floor(left % 3600 / 60)), s: pad(left % 60) };
    $("[data-cd]").forEach(function (el) { el.textContent = v[el.getAttribute("data-cd")] || "00"; });
    return left;
  }
  function tick() { if (paintCd() > 0) setTimeout(tick, 1000); }
  function initCountdown() { if (perkLive && !cdOn) { cdOn = true; tick(); } }

  /* Sticky bar: after the hero CTA, hidden while the buy-box CTA or the final band is on screen */
  var stickyOn = false;
  function vis(el) { if (!el) return false; var r = el.getBoundingClientRect(); return r.top < window.innerHeight && r.bottom > 0; }
  function upd() {
    var sticky = document.getElementById("ejSticky");
    if (!sticky) return;
    var hero = document.getElementById("ejHeroCta");
    var past = hero ? hero.getBoundingClientRect().bottom < 0 : window.scrollY > 600;
    var on = past && !vis(document.getElementById("ejBuyCta")) && !vis(document.querySelector(".ej-blk"));
    sticky.classList.toggle("on", on);
    sticky.setAttribute("aria-hidden", on ? "false" : "true");
    var a = sticky.querySelector("a");
    if (a) a.tabIndex = on ? 0 : -1;
  }
  function initSticky() {
    if (!stickyOn) {
      stickyOn = true;
      var ticking = false;
      window.addEventListener("scroll", function () { if (!ticking) { ticking = true; window.requestAnimationFrame(function () { ticking = false; upd(); }); } }, { passive: true });
      window.addEventListener("resize", upd);
    }
    upd();
  }

  /* "Read more" on mobile: [data-ej-more] paragraphs are clamped by CSS (ej-lp.css); the toggle only
     appears when the text is actually cut. Desktop shows the full text and no button. */
  function initMore() {
    $("[data-ej-more]").forEach(function (p) {
      if (p.__ejMore) return;
      p.__ejMore = true;
      var more = p.getAttribute("data-more-label") || "Leggi di più", less = p.getAttribute("data-less-label") || "Mostra meno";
      var btn = document.createElement("button");
      btn.type = "button";
      btn.className = "ej-more-btn";
      btn.setAttribute("aria-expanded", "false");
      btn.innerHTML = '<span></span><svg width="12" height="12" viewBox="0 0 24 24" aria-hidden="true"><path d="M6 9l6 6 6-6" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      btn.firstChild.textContent = more;
      p.parentNode.insertBefore(btn, p.nextSibling);
      var check = function () { if (!p.classList.contains("is-open")) btn.hidden = p.scrollHeight <= p.clientHeight + 2; };
      btn.addEventListener("click", function () {
        var open = p.classList.toggle("is-open");
        btn.setAttribute("aria-expanded", open ? "true" : "false");
        btn.firstChild.textContent = open ? less : more;
        if (!open) check();
      });
      check();
      window.addEventListener("resize", check);
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(check);
    });
  }

  function initAll() {
    initMore();
    fill(); initBundles(); initCtas(); initGallery(); initModal();
    initCarousels(); initTabs(); initCountdown(); initSticky(); initCart();
  }
  initAll();
  document.addEventListener("shopify:section:load", initAll);
})();
